/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerReprocessDocumentMutationResponse, DocumentUseCasesControllerReprocessDocumentPathParams, DocumentUseCasesControllerReprocessDocument400, DocumentUseCasesControllerReprocessDocument401, DocumentUseCasesControllerReprocessDocument403 } from "../../models/documentUseCasesController/DocumentUseCasesControllerReprocessDocument";

function getDocumentUseCasesControllerReprocessDocumentUrl(id: DocumentUseCasesControllerReprocessDocumentPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/documents/${id}/reprocessings` as const }  
  return res
}

/**
 * @description Creates a reprocessing operation with updated parameters or retry failed steps. Returns the operation resource with status and related job information. Supports both local (API) and job (WORKER) execution modes.
 * @summary Create a document reprocessing operation
 * {@link /api/v1/documents/:id/reprocessings}
 */
export async function documentUseCasesControllerReprocessDocument(id: DocumentUseCasesControllerReprocessDocumentPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerReprocessDocumentMutationResponse, ResponseErrorConfig<DocumentUseCasesControllerReprocessDocument400 | DocumentUseCasesControllerReprocessDocument401 | DocumentUseCasesControllerReprocessDocument403>, unknown>({ method : "POST", url : getDocumentUseCasesControllerReprocessDocumentUrl(id).url.toString(), ... requestConfig })  
  return res.data
}